/**
 * model representing Angular form submission data for
 * a Service Provided by an Organization in response to a Disaster
 */
export interface ServiceFormData {
  directProportion: number;
  indirectProportion: number;
  serviceProvided: { serviceId: number };
}
